import React from 'react';
import cn from 'classnames';

import Button from 'components/Button';
import Tooltip from 'components/Tooltip';
import { ReactComponent as CopyIcon } from 'assets/imgs/copy.svg';
import Modal from '../';
import classes from './modalInfoSubclientLoginSuccess.module.scss';
import { IModalInfoSubclientLoginSuccess } from './types';

const ModalInfoSubclientLoginSuccess: React.FC<
	IModalInfoSubclientLoginSuccess
> = ({
	className,
	isOpen,
	onClose,
	title = 'Учетная запись создана',
	text,
	login = '',
	password = '',
	passwordTooltip,
	buttonText = 'Продолжить',
	buttonClassName = '',
}) => {
	const handleCopyData = (data: string) => (): void => {
		if (data && navigator.clipboard) {
			navigator.clipboard.writeText(data);
		}
	};

	const loginInfo = (
		<div className={classes.info}>
			<div className={classes.label}>Ваш логин:</div>
			<div className={classes.data} title={login}>
				{login}
			</div>
			<CopyIcon
				className={classes.icon}
				onClick={handleCopyData(login)}
			/>
		</div>
	);

	const passwordInfo = (
		<div
			className={cn(classes.info, {
				[classes.info__withTooltip]: passwordTooltip,
			})}
		>
			<div className={classes.label}>Временный пароль:</div>
			<div className={classes.data}>••••••••••••••</div>
			<CopyIcon
				className={classes.icon}
				onClick={handleCopyData(password)}
			/>
			{passwordTooltip && (
				<Tooltip className={classes.tooltip} text={passwordTooltip} />
			)}
		</div>
	);

	return (
		<Modal
			className={cn(classes.modalInfoSubclientLoginSuccess, className)}
			isOpen={isOpen}
			onClose={onClose}
		>
			{title && <div className={classes.title}>{title}</div>}
			{text && <div className={classes.text}>{text}</div>}
			{login && loginInfo}
			{password && passwordInfo}

			<Button
				className={cn(classes.button, buttonClassName)}
				text={buttonText}
				onClick={onClose}
			/>
		</Modal>
	);
};

export default ModalInfoSubclientLoginSuccess;
